import { useRouter }                from 'next/router';
import { useSelector, useDispatch } from 'react-redux';
import UINotifications              from 'components/UI/Notifications';
import SignInForm                   from './Form';
import API                          from 'api';
import { setCookie }                from 'helpers/cookies';
import { TOKEN_COOKIE_NAME }        from 'helpers/constants';
import { useProductEvents }         from 'hooks';
import isEmpty                      from 'lodash/isEmpty';

function ConnectedSignInForm (props) {
  const smsCode = useSelector(state => state.smsCode);
  const signIn = useSelector(state => state.signIn);
  const router = useRouter();
  const dispatch = useDispatch();
  const events = useProductEvents();
  const { thenURL } = props;

  const authenticateByCode = (model) => {
    const _model = {...model};

    delete _model.phone;
    _model.expiresIn = 'P180D';

    const promise = dispatch(API.mutations.authenticateByCode({ input: _model }));

    promise
    .then((res) => {
      const { token, actor } = res.data.authenticateByCode;

      if (actor?.phone) {
        events.setUser(actor.phone);
      }

      events.send('login_success_workshop');
      
      setCookie(TOKEN_COOKIE_NAME, token, 180);

      thenURL ? router.replace(thenURL) : router.replace('/workbench');
    })
    .catch(err => {
      events.send('login_fail_workshop', {error: {...err.data}});

      if (!isEmpty(err.data)) {
        err.data.forEach(item => {
          UINotifications.show({
            type: 'danger',
            html: item.message
          });
        })
      }
    });

    return promise;
  };

  return (
    <SignInForm
      smsCode={smsCode}
      signIn={signIn}
      authenticateByCode={authenticateByCode}
      {...props}
    />
  )
};

export default ConnectedSignInForm;